import { DSModal } from "@components/design-system/organisms";

const ConfirmTemplateDeleteModal = ({
  shouldShow,
  hideModal,
  confirmAction,
}) => (
  <DSModal
    isOpen={shouldShow}
    onClose={hideModal}
    title="Delete Template"
    actions={[
      { label: "Cancel", variant: "cancel", onClick: hideModal },
      {
        label: "Delete",
        variant: "primary",
        onClick: confirmAction,
        dataTestId: "confirm-button",
      },
    ]}
    dataTestId="confirm-template-delete-modal"
  >
    <p>
      Deleting the template will erase all data you&apos;ve entered so
      far for this template. <b>This action cannot be undone.</b>
    </p>
    <p>Are you sure you want to proceed?</p>
  </DSModal>
);

export default ConfirmTemplateDeleteModal;
